import React from 'react';
import { useTranslation } from 'react-i18next';

import PanelCard from '../../performance-operations/components/PanelCard';
import { KpiSub, KpiValue } from '../../performance-operations/styles';
import { fmt, hasNum, metricText } from '../config';

// Analiz §16 E13 üst alan — geri bildirim sayısı M39, alan çalışan kapsaması M40, yönetici geri bildirim kapsaması M41 ve görüşme
// tamamlanma M42 (yalnız kiracı ayarıyla; kapalıysa neden metni) + takdir sayısı ve talep yanıt oranı. Geri bildirim sayısı kalite
// puanı DEĞİLDİR (kartta açıkça yazar). Kapsam n < k ise bütün kartlar "Gizli" gösterir.
function Card({ code, title, value, sub, panel, span = 2 }) {
  return (
    <PanelCard panelKey={`kpi-${code}`} title={title} span={span} kpi compact loading={panel.loading} error={panel.error} onRetry={panel.retry}>
      <KpiValue data-kpi={code}>{value}</KpiValue>
      {sub ? <KpiSub>{sub}</KpiSub> : null}
    </PanelCard>
  );
}

export default function FeedbackKpis({ panel }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const s = panel.data;
  const ratio = (m) => (m && hasNum(m.numerator) && hasNum(m.denominator) && !m.suppressionReason
    ? t('performance.operations.kpi.ratio', { num: fmt(m.numerator, lang, 0), den: fmt(m.denominator, lang, 0) }) : '');
  const hidden = !!s?.suppressionReason;
  const requests = s?.requests;
  return (
    <>
      <Card code="M39" panel={panel} title={t('performance.feedbackAnalytics.kpi.m39')} value={metricText(s?.m39, t, lang)}
        sub={hidden ? t('performance.feedbackAnalytics.suppressedNote') : t('performance.feedbackAnalytics.kpi.m39Sub')} />
      <Card code="M40" panel={panel} title={t('performance.feedbackAnalytics.kpi.m40')} value={metricText(s?.m40, t, lang)} sub={ratio(s?.m40)} />
      <Card code="M41" panel={panel} title={t('performance.feedbackAnalytics.kpi.m41')} value={metricText(s?.m41, t, lang)} sub={ratio(s?.m41)} />
      <Card code="M42" panel={panel} title={t('performance.feedbackAnalytics.kpi.m42')} value={metricText(s?.m42, t, lang)}
        sub={s && !s.oneOnOneEnabled ? t('performance.feedbackAnalytics.oneOnOneOff') : ratio(s?.m42)} />
      <Card code="recognition" panel={panel} title={t('performance.feedbackAnalytics.kpi.recognition')}
        value={hidden ? t('performance.feedbackAnalytics.suppressed') : (hasNum(s?.recognitionCount) ? fmt(s.recognitionCount, lang, 0) : '')}
        sub={s?.privateRecognitionCounted ? t('performance.feedbackAnalytics.privateCounted') : t('performance.feedbackAnalytics.publicOnly')} />
      <Card code="requests" panel={panel} title={t('performance.feedbackAnalytics.kpi.requests')}
        value={hidden ? t('performance.feedbackAnalytics.suppressed')
          : (hasNum(requests?.responseRate) ? `${fmt(requests.responseRate, lang)}%` : t('performance.operations.kpi.noData'))}
        sub={hidden || !requests ? '' : t('performance.feedbackAnalytics.kpi.requestsSub', {
          total: requests.total ?? 0, completed: requests.completed ?? 0, pending: requests.pending ?? 0,
        })} />
    </>
  );
}
